export default function initHeaderScroll() {
    // ==========================================================
    // HEADER SCROLL
    // ==========================================================

    const header = document.querySelector(".site-header");

    if (header) {
        let lastScrollY = window.scrollY;
        let ticking = false;

        const hideThreshold = 150;
        const scrollDelta = 6;

        const updateHeader = () => {
            const currentScrollY = Math.max(window.scrollY, 0);
            const difference = currentScrollY - lastScrollY;

            // Haut de page
            if (currentScrollY <= hideThreshold) {
                header.classList.remove("is-hidden", "is-visible");

                lastScrollY = currentScrollY;
                ticking = false;

                return;
            }

            // Ignorer les micro mouvements
            if (Math.abs(difference) < scrollDelta) {
                ticking = false;

                return;
            }

            // Descente
            if (difference > 0) {
                header.classList.add("is-hidden");
                header.classList.remove("is-visible");
            }

            // Remontée
            if (difference < 0) {
                header.classList.add("is-visible");
                header.classList.remove("is-hidden");
            }

            lastScrollY = currentScrollY;
            ticking = false;
        };

        window.addEventListener(
            "scroll",
            () => {
                if (!ticking) {
                    window.requestAnimationFrame(updateHeader);

                    ticking = true;
                }
            },
            {
                passive: true,
            },
        );
    }
}
